import { FC, useContext } from 'react';

import {
  Separator,
  CalendarIcon,
  ComputerIcon,
  PrinterIcon,
  ShopIcon,
  WalletIcon,
} from '@smartshell/ui-kit';
import dayjs from 'dayjs';

import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';
import { IReportPayment } from 'types';

import s from './CustomTooltip.module.scss';

interface ITooltipProps {
  payment: IReportPayment;
}

export const CustomTooltip: FC<ITooltipProps> = ({ payment }) => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { currency },
    },
  } = useContext(SettingsContext);

  if (!payment) {
    return null;
  }

  const { created_at, total, sumByItemType } = payment;

  if (!sumByItemType) {
    return null;
  }

  const {
    TARIFF: tariffsSum,
    GOOD: goodsSum,
    SERVICE: servicesSum,
    DEPOSIT: depositSum,
  } = sumByItemType;

  return (
    <div className={s.container}>
      <div className={s.header}>
        <div className={s.date}>
          <CalendarIcon size="s" />
          {dayjs(created_at).format('DD.MM HH:mm:ss')}
        </div>
        <div className={s['divider']} />
        <div>
          {total.toLocaleString()} {currency.sign}
        </div>
      </div>
      <Separator />
      {tariffsSum !== undefined && (
        <div className={s['payment-item']}>
          <ComputerIcon size="s" />
          {t('workShift.detail.chart.tariffs')}
          <span className={s.sum}>
            {tariffsSum.toLocaleString()} {currency.sign}
          </span>
        </div>
      )}
      {goodsSum !== undefined && (
        <div className={s['payment-item']}>
          <ShopIcon size="s" />
          {t('workShift.detail.chart.goods')}
          <span className={s.sum}>
            {goodsSum.toLocaleString()} {currency.sign}
          </span>
        </div>
      )}
      {servicesSum !== undefined && (
        <div className={s['payment-item']}>
          <PrinterIcon size="s" />
          {t('workShift.detail.chart.services')}
          <span className={s.sum}>
            {servicesSum.toLocaleString()} {currency.sign}
          </span>
        </div>
      )}
      {depositSum !== undefined && (
        <div className={s['payment-item']}>
          <WalletIcon size="s" />
          {t('workShift.detail.chart.deposit')}
          <span className={s.sum}>
            {depositSum.toLocaleString()} {currency.sign}
          </span>
        </div>
      )}
    </div>
  );
};
